export default class AssetManager {
  public static getLibForChar(name: string): string {
    return require(`lib/assets/character/${name}`);
  }

  public static getLibShared(name: string): string {
    return require(`lib/assets/shared/${name}`);
  }

  public static getForChar(name: string): string {
    return require(`src/assets/character/${name}`);
  }

  public static getShared(name: string): string {
    return require(`src/assets/shared/${name}`);
  }
}



// WEBPACK FOOTER //
// ../lib/src/AssetManager.ts